import { render, staticRenderFns } from "./DimBookInput.vue?vue&type=template&id=1a4313a6"
import script from "./DimBookInput.vue?vue&type=script&lang=js"
export * from "./DimBookInput.vue?vue&type=script&lang=js"
import style0 from "./DimBookInput.vue?vue&type=style&index=0&id=1a4313a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports